import React from 'react';
import './SubPages.css';
import HomeButton from './HomeButton';
import Footer from './Footer';

const HelpPage = () => (
  <div className="subpage-container">
    <HomeButton />
    <h1>Help Center</h1>
    <div className="subpage-content">
      <h2>How do I start a chat?</h2>
      <p>Simply log in to your dashboard and click the "New Chat" icon to begin interacting with OZIA AI.</p>
      
      <h2>Is my data secure?</h2>
      <p>Yes. We use end-to-end encryption and Firebase's secure architecture to ensure your conversations remain private.</p>

      <h2>Can I upgrade my plan?</h2>
      <p>You can manage your subscription at any time via the "Pricing" section in your account settings.</p>
    </div>
                <div className="footer-wrapper">
                <Footer />
            </div>
  </div>
);

export default HelpPage;